import * as React from 'react';
export var HeadingLevel;
(function (HeadingLevel) {
    HeadingLevel[HeadingLevel["H2"] = 2] = "H2";
    HeadingLevel[HeadingLevel["h3"] = 3] = "h3";
    HeadingLevel[HeadingLevel["h4"] = 4] = "h4";
})(HeadingLevel || (HeadingLevel = {}));
export var HeadingComponent = function (props) {
    var value = props.value;
    var level = value.level;
    var DynamicHeadingTag = "h".concat(level) || 3;
    return (React.createElement("div", { className: 'component heading-component', "data-component-type": 'heading' },
        React.createElement(DynamicHeadingTag, { className: 'heading-text', id: value.anchorId }, value.text)));
};
//# sourceMappingURL=heading-component.comp.js.map